import classNames from 'classnames';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Text } from '@feathr/components';

import RightPanelTabsBeta from './RightPanelTabs.beta';

import * as styles from './RightPanelTabs.css';

interface IProps {
  activeTab: 'preview' | 'embed';
  formName: string;
  handleTabClick: (tab: 'preview' | 'embed') => void;
}

function RightPanelTabs({ activeTab, formName, handleTabClick }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  function handleClickPreview(): void {
    handleTabClick('preview');
  }

  function handleClickEmbed(): void {
    handleTabClick('embed');
  }

  return (
    <div className={styles.root}>
      <Button
        className={classNames(styles.tab, styles.right, {
          [styles.active]: activeTab === 'preview',
        })}
        onClick={handleClickPreview}
        type={'naked'}
      >
        <Text.LargeSemibold
          className={classNames({
            [styles.inactive]: activeTab !== 'preview',
          })}
        >
          {formName}
        </Text.LargeSemibold>
      </Button>
      <Button
        className={classNames(styles.tab, {
          [styles.active]: activeTab === 'embed',
        })}
        onClick={handleClickEmbed}
        type={'naked'}
      >
        <Text.LargeSemibold
          className={classNames({
            [styles.inactive]: activeTab !== 'embed',
          })}
        >
          {t('Embed')}
        </Text.LargeSemibold>
      </Button>
    </div>
  );
}

RightPanelTabs.Beta = RightPanelTabsBeta;

export default RightPanelTabs;
